/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */

export type ClubsControllerListClubsV1SortBy = typeof ClubsControllerListClubsV1SortBy[keyof typeof ClubsControllerListClubsV1SortBy];


export const ClubsControllerListClubsV1SortBy = {
  name: 'name',
  country: 'country',
  founded: 'founded',
  recent: 'recent',
} as const;
